import { render, staticRenderFns } from "./TransferShopModal.vue?vue&type=template&id=199720de&scoped=true"
import script from "./TransferShopModal.vue?vue&type=script&lang=ts"
export * from "./TransferShopModal.vue?vue&type=script&lang=ts"
import style0 from "./TransferShopModal.vue?vue&type=style&index=0&id=199720de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199720de",
  null
  
)

export default component.exports